/* unplugin-vue-components disabled */import script from "./BaseMap.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMap.vue?vue&type=script&setup=true&lang=js"

import "./BaseMap.vue?vue&type=style&index=0&id=070cb48e&scoped=true&lang=scss"
import "./BaseMap.vue?vue&type=style&index=1&id=070cb48e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070cb48e"]])

export default __exports__